import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "21"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<g fill=\"none\" fill-rule=\"evenodd\"><rect width=\"17.6\" height=\"18.6\" x=\"1.2\" y=\"1.2\" stroke=\"currentColor\" stroke-width=\"2.4\" rx=\"2\"></rect><g transform=\"translate(4.828 4.9)\"><path stroke=\"currentColor\" stroke-linecap=\"round\" stroke-width=\"2.4\" d=\"M.94 7.467h8.631\"></path><ellipse cx=\"2.351\" cy=\"2.333\" fill=\"currentColor\" rx=\"2.351\" ry=\"2.333\"></ellipse></g></g>", 1)
  ]))]))
}
export default { render: render }